export enum ReturnWasteTransactionTypes {
  Return = 104,
  Waste = 1,
}
